import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@tellescope/tanstack-query";
import { getRouteComponent } from "./get-route-component";
import { ROUTES_CONFIG } from "./routes-config";
import type { ShouldShowContext } from "./types";

export const RouterContent = () => {
  const { session, selectedOrganization, currentUser, isAuthenticated, isInitializing } = useAuth();

  const shouldShowContext: ShouldShowContext | null =
    isAuthenticated && !isInitializing && currentUser && selectedOrganization
      ? { session, selectedOrganization, currentUser }
      : null;

  return (
    <Routes>
      {Object.entries(ROUTES_CONFIG).map(([path, config]) =>
        getRouteComponent({ path, ...config }, { shouldShowContext })
      )}

      {/* Default redirect to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Catch all route - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};
